//jshint esversion:6
import '../styles/contact.css';
function Contact() {
  return (
    <div className='container-fluid contact'>
      {/* <h1 className='ah1'>Contact</h1>
      {/* <h1 className='bh1'>Contact</h1>
      <h1 className='ch1'>Contact</h1> */}{' '}
      */}
    </div>
  );
}

export default Contact;
